import notify from '../Style-guide/ToastMessage';
import Translations from '../Translations';
import { getLanguage } from '../Translations/languageManager';

export default async function handleBadResponse(response) {
  if (!response.ok) {
    let message = response.statusText || 'Something went wrong';
    let translationKey = null;
    const language = getLanguage();

    try {
      const errorData = await response.clone().json();

      if (errorData?.message) {
        message = errorData.message;
        translationKey = errorData.translationKey;
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn('Could not parse error response as JSON:', e);
    }

    const translatedMessage = Translations[language].errors[translationKey] || message;

    /// Token expiry handling
    if (response.status === 401) {
      if (message === 'Your session has expired') {
        /// trigger useLogout hook via window event
        window.dispatchEvent(new Event('session-expired'));

        return;
      }

      const error = new Error(message);
      error.status = response.status;
      notify.error(translatedMessage);

      throw error;
    }

    notify.error(translatedMessage);

    const error = new Error(message);
    error.status = response.status;
    error.ok = false;
    throw error;
  }

  return response;
}
